import { NavLink, useLocation } from "react-router-dom";
import Button from '@mui/material/Button';
import './header.component.scss';
import MenuModel from "../../models/menu.model";
import { CONSTANTS } from "../../constants/constants";
import React, { useEffect } from "react";
import SubMenuComponent from "../submenu/submenu.component";
import { UsuarioEfetuouLoginService } from "../../services/usuario-efetuou-login.service";
import UsuarioModel from "../../models/usuario.model";

export type HeaderComponentProps = {
  menu?: MenuModel;
}

function HeaderComponent(props: HeaderComponentProps) {
  const location = useLocation();
  const [openMenu, setOpenMenu] = React.useState<boolean>(false);
  const [usuarioLogado, setUsuarioLogado] = React.useState<UsuarioModel>();

  useEffect(() => {
    changeFavIcon();
    if (props.menu && usuarioLogado) {
      localStorage.setItem("author_id", props.menu.author_id);
      localStorage.setItem("nome_do_site", props.menu.nome_do_site);
      localStorage.setItem("logo", props.menu.logo.src);
    }

    UsuarioEfetuouLoginService.getMSG().subscribe((usuarioService: any) => {
      setUsuarioLogado(usuarioService);
    });

    let usLogado = localStorage.getItem("user");
    if (usLogado) {
      setUsuarioLogado(JSON.parse(usLogado));
    }
  }, [location])

  const changeFavIcon = () => {
    let link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = props.menu?.favicon;

    let link2: any = document.querySelector("link[rel~='apple-touch-icon']");
    if (!link2) {
      link2 = document.createElement('link');
      link2.rel = 'apple-touch-icon';
      document.getElementsByTagName('head')[0].appendChild(link2);
    }
    link2.href = props.menu?.favicon;
  }

  const toggleBurger = () => {
    setOpenMenu(!openMenu);
  }

  const clickMenuScroll = (e, itemMenu) => {
    e.preventDefault(); // impede que o navegador adicione a hash
    toggleBurger();
    if (!itemMenu.sem_acao) {
      const target = document.getElementById(itemMenu.id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  const css = `
    .hamburger.is-active .hamburger-inner, 
    .hamburger.is-active .hamburger-inner:after, 
    .hamburger.is-active .hamburger-inner:before {
        background-color: ${props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#000'};
    }

    .hamburger-inner, .hamburger-inner:after, 
    .hamburger-inner:before {
      background-color: ${props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#000'};
  }
  `;

  return (
    <>
      <style>{css}</style>
      <header style={{
        backgroundColor: props.menu?.cor_bg_menu ? props.menu?.cor_bg_menu : '#333'
      }}>
        <div className="container">
          <div className={props.menu?.posicao_logo === CONSTANTS.POSICAO_LOGO.CENTRO ? "flex flex-ch flex-cv" : "flex flex-sp flex-cv"}>
            {
              (props.menu?.logo && props.menu.posicao_logo === CONSTANTS.POSICAO_LOGO.ESQUERDA) &&
              <img src={props.menu?.logo.src} alt="Logo" />
            }

            {
              props.menu?.posicao_logo === CONSTANTS.POSICAO_LOGO.CENTRO ?
                <>
                  {
                    props.menu?.logo &&
                    <img className="logo-centro mobile" src={props.menu?.logo.src} alt="Logo" />
                  }

                  <div
                    className={"menu-suspenso flex flex-ch flex-cv " + (openMenu && 'is-active')}
                    style={{
                      backgroundColor: props.menu?.cor_bg_menu ? props.menu?.cor_bg_menu : '#333'
                    }}
                  >
                    <nav>
                      <ul className="flex flex-sp flex-cv">
                        {
                          props.menu?.itens.map((itemMenu, iMenu) => (
                            <>
                              {
                                (iMenu <= (props.menu ? Math.floor(props.menu?.itens.filter(x => x.submenu === '').length / 2) : 0) && itemMenu.submenu === '') &&
                                <li key={iMenu}>
                                  {
                                    props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                                      <Button
                                        style={{
                                          color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                        }}
                                        onClick={(e) => {clickMenuScroll(e, itemMenu)}} >{itemMenu.nome}</Button>
                                      :
                                      <>
                                        {
                                          !itemMenu.submenu &&
                                          <>
                                            {
                                              (props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente)).length) ?
                                                <SubMenuComponent
                                                  cor_fundo_submenu={props.menu.cor_fundo_submenu}
                                                  cor_texto_submenu={props.menu.cor_texto_submenu}
                                                  subMenus={props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente))}
                                                  itemMenu={itemMenu} cor_texto_menu={props.menu.cor_texto_menu}
                                                  clickItemSubmenu={toggleBurger}
                                                />
                                                :
                                                <NavLink exact={true} to={itemMenu.sem_acao ? '#' : CONSTANTS.TIPO_MENU.NOVA_PAGINA + itemMenu.id_do_componente} activeClassName="active">
                                                  <Button
                                                    style={{
                                                      color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                                    }}
                                                  >{itemMenu.nome}</Button>
                                                </NavLink>
                                            }
                                          </>
                                        }
                                      </>
                                  }
                                </li>
                              }
                            </>
                          ))
                        }
                      </ul>
                    </nav>

                    {
                      props.menu?.logo &&
                      <img className="logo-centro desktop" src={props.menu?.logo.src} alt="Logo" />
                    }

                    <nav>
                      <ul className="flex flex-sp flex-cv">
                        {
                          props.menu?.itens.map((itemMenu, iMenu) => (
                            <>
                              {
                                (iMenu > (props.menu ? Math.floor(props.menu?.itens.filter(x => x.submenu === '').length / 2) : 0) && itemMenu.submenu === '') &&
                                <li key={iMenu}>
                                  {
                                    props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                                      <Button
                                        style={{
                                          color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                        }}
                                        onClick={(e) => {clickMenuScroll(e, itemMenu)}}>{itemMenu.nome}</Button>
                                      :
                                      <>
                                        {
                                          !itemMenu.submenu &&
                                          <>
                                            {
                                              (props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente)).length) ?
                                                <SubMenuComponent
                                                  cor_fundo_submenu={props.menu.cor_fundo_submenu}
                                                  cor_texto_submenu={props.menu.cor_texto_submenu}
                                                  subMenus={props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente))}
                                                  itemMenu={itemMenu} cor_texto_menu={props.menu.cor_texto_menu}
                                                  clickItemSubmenu={toggleBurger}
                                                />
                                                :
                                                <NavLink exact={true} to={itemMenu.sem_acao ? '#' : CONSTANTS.TIPO_MENU.NOVA_PAGINA + itemMenu.id_do_componente} activeClassName="active">
                                                  <Button
                                                    style={{
                                                      color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                                    }}
                                                  >{itemMenu.nome}</Button>
                                                </NavLink>
                                            }
                                          </>
                                        }
                                      </>
                                  }
                                </li>
                              }
                            </>
                          ))
                        }
                      </ul>
                    </nav>
                  </div>
                </>
                :
                <div
                  className={"menu-suspenso flex flex-ch flex-cv " + (openMenu && 'is-active')}
                  style={{
                    backgroundColor: props.menu?.cor_bg_menu ? props.menu?.cor_bg_menu : '#333'
                  }}
                >
                  <nav>
                    <ul className="flex flex-sp flex-cv">
                      {
                        props.menu?.itens.map((itemMenu, iMenu) => (
                          <li key={iMenu}>
                            {
                              props.menu?.tipo_menu === CONSTANTS.TIPO_MENU.SCROLL ?
                                <Button
                                  style={{
                                    color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                  }}
                                  onClick={(e) => {clickMenuScroll(e, itemMenu)}}>{itemMenu.nome}</Button>
                                :
                                <>
                                  {
                                    !itemMenu.submenu &&
                                    <>
                                      {
                                        (props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente)).length) ?
                                          <SubMenuComponent
                                            cor_fundo_submenu={props.menu.cor_fundo_submenu}
                                            cor_texto_submenu={props.menu.cor_texto_submenu}
                                            subMenus={props.menu?.itens.filter(x => x.submenu === (itemMenu.id_do_componente === '' ? 'home' : itemMenu.id_do_componente))}
                                            itemMenu={itemMenu} cor_texto_menu={props.menu.cor_texto_menu}
                                            clickItemSubmenu={toggleBurger}
                                          />
                                          :
                                          <NavLink exact={true} to={itemMenu.sem_acao ? '#' : CONSTANTS.TIPO_MENU.NOVA_PAGINA + itemMenu.id_do_componente} activeClassName="active">
                                            <Button
                                              style={{
                                                color: props.menu?.cor_texto_menu ? props.menu?.cor_texto_menu : '#fff'
                                              }}
                                              onClick={toggleBurger}
                                            >{itemMenu.nome}</Button>
                                          </NavLink>
                                      }
                                    </>
                                  }
                                </>
                            }
                          </li>
                        ))
                      }
                    </ul>
                  </nav>
                </div>
            }

            {
              (props.menu?.logo && props.menu.posicao_logo === CONSTANTS.POSICAO_LOGO.DIREITA) &&
              <img src={props.menu?.logo.src} alt="Logo" />
            }

            <button onClick={toggleBurger} className={"hamburger hamburger--3dxy " + (openMenu && 'is-active')} type="button">
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default HeaderComponent;
